{
  "version": 1,
  "asset_id": "87dbc17f-f390-4f89-8bfe-b11f37acd1f7",
  "project_id": "01579873-aba5-45c2-b48e-0fe42afbbb35",
  "url": "/__l5e/assets-v1/87dbc17f-f390-4f89-8bfe-b11f37acd1f7/footer.png",
  "r2_key": "a/v1/01579873-aba5-45c2-b48e-0fe42afbbb35/87dbc17f-f390-4f89-8bfe-b11f37acd1f7/footer.png",
  "original_filename": "footer.png",
  "size": 49718,
  "content_type": "image/png",
  "created_at": "2026-06-16T18:26:07Z"
}
